// Daily usage limits for free (non-Pro) users.
// Tune these numbers to adjust feature access.

export const FREE_LIMITS = {
  search: 10, // Flights & Stays / Stays Only searches per day
  explore: 10, // AI Explore searches per day
  reviews: 10, // AI Review Analyzer uses per day
  tripplanner: 10, // AI Trip Planner uses per day
};
